// extracted by mini-css-extract-plugin
export default {"title":"UploadModal_title__TkT7M","text":"UploadModal_text__11zLR","progressBar":"UploadModal_progressBar__nbjHW","innerProgressBar":"UploadModal_innerProgressBar__KXV65"};